import { createSlice } from '@reduxjs/toolkit'
import { ADD } from '../../utils/Constants'

export const UUMReducer = createSlice({
    name: 'uum',
    initialState: {
        //Users
        userTableSchema: [],
        userTableList: null,
        userFilteredList: [],
        userDetailSchema: {},
        userDetailData: {},
        disableCreateBtn: false,
        validateForDECTUserDelete: false,

        //Users profiles
        profileTableSchema: [],
        profileTableList: null,
        profileFilteredList: [],
        profileSummarySchema: [],
        profileDetailSchema: {},
        profileDetailData: {},

        //Multi Device
        multiDeviceSchema: {},
        MultiDeviceData: {},
        disableMultiDvcDECTOKBtn: false,

        //Groups
        groupTableSchema: [], //list view schema variable
        groupTableList: null, //list view data
        groupFilteredList: [], //filtered pickup group data 
        groupSummarySchema: [], //-----not needed----------
        pickupGroupDetail: [], //detail view schema and data - create
        existingGroupDetail: [], //detail view schema and data - update
        groupDetailData: {}, // ---not needed-------------
        groupAndUsers: [], //for deepSearch of users in a group
        unAssociatedUsersOfPickupGroup: [], // to store unassocuated users of pickup group

        huntGroupTableSchema: [], //list view schema variable
        huntGroupTableList: null, //list view data
        huntGroupFilteredList: [], //filtered hunting group data
        huntingGroupDetail: [], //detail view schema and data - create
        existingHuntingGroupDetail: [], //detail view schema and data - update
        unAssociatedUsersOfHuntingGroup: [], // to store unassociated users of hunting group

        existingUsersOfGroup: [], //to store exisitng users of a group during update from create api response

        //Directory Synchro
        directorySynchroTableSchema: [],
        directorySynchroTableList: null,
        directorySynchroFilteredList: null,
        isUpdateAuto: true,
        isEntraConnectionEstablished: false,
        directorySynchroConfigData:null,
        directorySynchroDetailedData:null,
        createUserFromDirectorySynchro: false,
        userSCIMId : [],
        currentUserSCIMIndex : 0,
        directorySynchroMode : null,
        directorySychroUserDN : [],
        directorySynchroCompareTableSchema: [],
        directorySynchroCompareDetailedData:null,
        tempComparedDetailedData:null,
        isCompareSyncwithOXE: false,
        isReplaceButtonClicked : false,

        //Others
        isUserProfileTab: true,
        isPickupGroupTab: true,
        dnNumberFromFreeRange: '',
        isDirSynchro :false
    },
    reducers: {
        setUserTableSchema: (state, action) => {
            state.userTableSchema = action.payload
        },
        setUserTableList: (state, action) => {
            state.userTableList = action.payload
            state.userFilteredList = action.payload
        },
        setUserFilteredList: (state, action) => {
            state.userFilteredList = action.payload
        },
        setProfileTableSchema: (state, action) => {
            state.profileTableSchema = action.payload
        },
        setProfileTableList: (state, action) => {
            state.profileTableList = action.payload
            state.profileFilteredList = action.payload
        },
        setProfileFilteredList: (state, action) => {
            state.profileFilteredList = action.payload
        },
        setProfileSummarySchema: (state, action) => {
            state.profileSummarySchema = action.payload
        },
        setIsUserProfileTab: (state, action) => {
            state.isUserProfileTab = action.payload
        },
        setProfileDetailSchema: (state, action) => {
            state.profileDetailSchema = action.payload
        },
        setUserDetailSchema: (state, action) => {
            state.userDetailSchema = action.payload
        },
        setProfileDetailData: (state, action) => {
            state.profileDetailData = action.payload
        },
        setUserDetailData: (state, action) => {
            state.userDetailData = action.payload
            state.validateForDECTUserDelete = false // Reset DECT validate flag on user data change 
            state.disableCreateBtn = action.payload === null ? false : state.disableCreateBtn // Reset create button state on resetting of userData
        },
        setDisableCreateBtn: (state, action) => {
            state.disableCreateBtn = action.payload
        },
        setValidateForDECTUserDelete: (state, action) => {
            state.validateForDECTUserDelete = action.payload
        },
        setMultiDeviceSchema: (state, action) => {
            state.multiDeviceSchema = action.payload
        },
        setMultiDeviceData: (state, action) => {
            state.MultiDeviceData = action.payload
        },
        setDisableMultiDvcDECTOKBtn: (state, action) => {
            state.disableMultiDvcDECTOKBtn = action.payload
        },
        //pickupgroup
        setGroupTableSchema: (state, action) => {
            state.groupTableSchema = action.payload
        },
        setGroupTableList: (state, action) => {
            state.groupTableList = action.payload
            state.groupFilteredList = action.payload
        },
        setGroupFilteredList: (state, action) => {
            state.groupFilteredList = action.payload
        },
        setGroupSummarySchema: (state, action) => {
            state.groupSummarySchema = action.payload
        },
        setPickupGroupDetail: (state, action) => {
            state.pickupGroupDetail = action.payload
        },
        setExistingGroupDetail: (state, action) => {
            state.existingGroupDetail = action.payload
        },
        setGroupAndUsers: (state, action) => {
            state.groupAndUsers = action.payload
        },
        setExistingUsersOfGroup: (state, action) => {
            state.existingUsersOfGroup = action.payload
        },
        //hunt group
        setHuntGroupTableSchema: (state, action) => {
            state.huntGroupTableSchema = action.payload
        },
        setHuntGroupTableList: (state, action) => {
            state.huntGroupTableList = action.payload
            state.huntGroupFilteredList = action.payload
        },
        setHuntGroupFilteredList: (state, action) => {
            state.huntGroupFilteredList = action.payload
        },
        setHuntingGroupDetail: (state, action) => {
            state.huntingGroupDetail = action.payload
        },
        setExistingHuntingGroupDetail: (state, action) => {
            state.existingHuntingGroupDetail = action.payload
        },
        setUnAssociatedUsersOfPickupGroup: (state, action) => {
            state.unAssociatedUsersOfPickupGroup = action.payload
        },
        setUnAssociatedUsersOfHuntingGroup: (state, action) => {
            state.unAssociatedUsersOfHuntingGroup = action.payload
        },
        setIsPickupGroupTab: (state, action) => {
            state.isPickupGroupTab = action.payload
        },
        setDirectorySynchroTableSchema: (state, action) => {
            state.directorySynchroTableSchema = action.payload
        },
        setDirectorySynchroTableList: (state, action) => {
            state.directorySynchroTableList = action.payload
            state.directorySynchroFilteredList = action.payload
        },
        setDirectorySynchroFilteredList: (state, action) => {
            state.directorySynchroFilteredList = action.payload
        },
        setIsUpdateAutoTab: (state, action) => {
            state.isUpdateAuto = action.payload
        },
        setIsEntraConnectionEstablished: (state, action) => {
            state.isEntraConnectionEstablished = action.payload
        },
        setDirectorySynchroConfigData: (state, action) => {
            state.directorySynchroConfigData = action.payload
        },
        setDirectorySynchroDetailedData: (state, action) => {
            state.directorySynchroDetailedData = action.payload
        },
        setCreateUserFromDirectorySynchro: (state, action) => {
            state.createUserFromDirectorySynchro = action.payload
        },
        setUserSCIMId: (state, action) => {
            state.userSCIMId = action.payload
        },
        setCurrentUserSCIMIndex: (state, action) => {
            state.currentUserSCIMIndex = action.payload
        },
        setDirectorySynchroMode: (state, action) => {
            state.directorySynchroMode = action.payload
        }, 
        setDirectorySychroUserDN: (state, action) => {
            state.directorySychroUserDN = action.payload
        },
        setDirectorySynchroCompareTableSchema: (state, action) => {
            state.directorySynchroCompareTableSchema = action.payload
        },
         setDirectorySynchroCompareDetailedData: (state, action) => {
            state.directorySynchroCompareDetailedData = action.payload
        },
        setTempComparedDetailedData: (state, action) => {
            state.tempComparedDetailedData = action.payload
        },
        setIsCompareSyncwithOXE: (state, action) =>{
            state.isCompareSyncwithOXE = action.payload
        },
        setIsReplaceButtonClicked: (state, action) =>{
            state.isReplaceButtonClicked = action.payload
        },
        setDnNumberFromFreeRange: (state, action)=>{
            state.dnNumberFromFreeRange = action.payload
        },
        setIsDirSynchro: (state, action) =>{
            state.isDirSynchro = action.payload
        }

    },
})

// Action creators are generated for each case reducer function
export const { setUserTableSchema, setUserTableList, setUserFilteredList, setProfileTableSchema,
    setProfileTableList, setProfileFilteredList, setProfileSummarySchema, setIsUserProfileTab, setProfileDetailSchema, setUserDetailSchema, setProfileDetailData,
    setDisableCreateBtn, setUserDetailData, setValidateForDECTUserDelete, setMultiDeviceSchema, setMultiDeviceData,
    setDisableMultiDvcDECTOKBtn,setGroupTableSchema,setGroupTableList,setGroupFilteredList,setGroupSummarySchema,
    setPickupGroupDetail,setExistingGroupDetail,setGroupAndUsers,setExistingUsersOfGroup,setHuntGroupTableSchema, setHuntGroupTableList,
    setHuntGroupFilteredList,setHuntingGroupDetail, setExistingHuntingGroupDetail,setUnAssociatedUsersOfPickupGroup,setUnAssociatedUsersOfHuntingGroup,
    setIsPickupGroupTab, setDirectorySynchroTableSchema, setDirectorySynchroTableList, setDirectorySynchroFilteredList, 
    setIsUpdateAutoTab, setIsEntraConnectionEstablished, setDirectorySynchroConfigData, setDirectorySynchroDetailedData,
    setCurrentUserSCIMIndex, setCreateUserFromDirectorySynchro, setUserSCIMId,setDirectorySynchroMode, setDirectorySychroUserDN, 
    setDirectorySynchroCompareTableSchema, setDirectorySynchroCompareDetailedData, setTempComparedDetailedData, setIsCompareSyncwithOXE, setIsReplaceButtonClicked, setDnNumberFromFreeRange, setIsDirSynchro } = UUMReducer.actions

export default UUMReducer.reducer